"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoPage = void 0;
const EsText_1 = require("./EsText");
class InfoPage {
    constructor(content) {
        this.id = 0;
        this.title = "";
        this.titleShort = "";
        this.order = 0;
        this.content = content;
    }
    get shortTitleOrTitle() {
        return this.titleShort ? this.titleShort : this.title;
    }
    static fromDto(infoPageDto) {
        const content = EsText_1.EsText.fromOptionalTextDto(infoPageDto.content);
        const track = new InfoPage(content);
        track.id = infoPageDto.id;
        track.title = infoPageDto.title;
        if (infoPageDto.titleShort) {
            track.titleShort = infoPageDto.titleShort;
        }
        track.order = infoPageDto.order;
        return track;
    }
    toDto() {
        const resultDto = {
            id: this.id,
            title: this.title,
            order: this.order
        };
        if (this.titleShort) {
            resultDto.titleShort = this.titleShort;
        }
        if (this.content.notEmpty) {
            resultDto.content = this.content.toOptionalTextDto();
        }
        return resultDto;
    }
}
exports.InfoPage = InfoPage;
